import { _CollectionsNamesWithSlug } from "./common.type";
import { firestore } from "@/api/firebase/firebase.config";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

export async function _createNewProfileDoc(
  // collectionName: _CollectionsNamesWithSlug,
  collectionName: string,
  data: Record<string, any>,
  tenant: string,
  docId?: string
) {
  return firestore
    .collection(collectionName)
    .doc(tenant)
    .collection("records")
    .doc(docId)
    .set(
      {
        created: firebase.firestore.FieldValue.serverTimestamp(),
        ...data,
      },
      { merge: true }
    );
}
